<script setup>
import {ref} from "vue";
import HpoPatientModalSection from "../HpoPatientModalSection.vue";
import * as yup from "yup";
import {stringValidator} from "@/utils/yupValidators";
import HpoHospitalRecordsMutation from "@/graphql/mutations/hpo/hospitalRecords.graphql"
import {useMutation} from "@vue/apollo-composable";
import {useDjangoForm} from "@/utils/forms";
import BarcodeScannerModal from "@/components/utils/BarcodeScannerModal.vue";
import {mdiBarcodeScan} from "@mdi/js";
// TODO: DELETE FILE WHEN NOT NEEDED

const props = defineProps({
    patientData: {
        type: Object,
        required: true,
    },
});
const emit = defineEmits(['close']);

const schema = yup.object({
    temporaryIdentifier: stringValidator,
    admittedToHospitalTimestamp: yup.date().nullable(),
    destinationWard: stringValidator,
});


console.log(props.patientData.patient.admittedToHospitalTimestamp);

function formatDateTime(date) {
    try {
        return date.format('YYYY-MM-DDTHH:mm');
    } catch (e) {
        return null;
    }
}

const {defineField, handleMutationSubmit, isSubmitting} = useDjangoForm({
    validationSchema: schema,
    initialValues: {
        temporaryIdentifier: props.patientData.patient.temporaryIdentifier,
        admittedToHospitalTimestamp: formatDateTime(props.patientData.patient.admittedToHospitalTimestamp),
        destinationWard: props.patientData.patient.destinationWard,
    },
});

const [temporaryIdentifier, temporaryIdentifierProps] = defineField('temporaryIdentifier');
const [admittedToHospitalTimestamp, admittedToHospitalTimestampProps] = defineField('admittedToHospitalTimestamp');
const [destinationWard, destinationWardProps] = defineField('destinationWard');

const {mutate, loading} = useMutation(HpoHospitalRecordsMutation)

const showBarcodeModal = ref(false);

function updateTemporaryIdentifier(value) {
    temporaryIdentifier.value = value;
}

const onSubmit = handleMutationSubmit(
    (values) => {
        return mutate({
            patientId: props.patientData.patient.id,
            hospitalId: props.patientData.patient.hospital.id,
            ...values,
            admittedToHospitalTimestamp: new Date(values.admittedToHospitalTimestamp),
        });
    },
    {
        onSuccess: () => {
            emit('close');
        },
    }
);

</script>

<template>
    <div class="tab-body">
        <HpoPatientModalSection :title="pgettext('label', 'Hospital records')">
            <template v-slot:body>
                <form @submit.prevent="onSubmit"
                      autocomplete="off">

                    <v-text-field v-model="admittedToHospitalTimestamp"
                                  :label="pgettext('label', 'Admitted to Hospital Timestamp')"
                                  type="datetime-local"
                                  v-bind="admittedToHospitalTimestampProps"/>

                    <v-text-field v-model="destinationWard" :label="pgettext('label', 'Destination Ward')"
                                  v-bind="destinationWardProps"/>

                    <v-btn :loading="isSubmitting" :disabled="loading" type="submit" block>
                        {{ pgettext('action', 'Save') }}
                    </v-btn>

                </form>
            </template>
        </HpoPatientModalSection>
    </div>

    <BarcodeScannerModal v-if="showBarcodeModal" @close="showBarcodeModal = false" @commitValue="updateTemporaryIdentifier" />
</template>
